import BaseModel from '@/models/base';

export default class Business extends BaseModel {
  static entity = 'businesses';
  static apiPath = 'businesses';
  static routeName = 'business';

  static fields() {
    return {
      id: this.attr(null),
      title: this.string(''),
      number: this.string(''),
      running_number: this.string(''),
      opening_date: this.date(null),
      closing_date: this.date(null),
      publishing_datetime: this.date(null),
      status: this.string('hängig'),
      kind: this.string('Verordnung'),
      created: this.attr(null),
      modified: this.attr(null),
      commission_id: this.attr(null),
      journal_entries: this.hasMany('journal_entries', 'business_id'),
      is_published: this.boolean(false),
    };
  }

  static get statuses() {
    return [
      'hängig',
      'abgeschlossen',
    ];
  }

  static get kinds() {
    return [
      'Verordnung',
      'Gesetz',
      'Einbürgerung',
      'Bericht',
      'Kredit',
      'Budget, Rechnung, Finanzplan',
      'Kantonsverfassung',
      'Konkordat',
      'Initiative',
      'Wahlen',
      'Aufsichtsbeschwerde',
      'Rekurse',
      'Begnadigung',
      'Verschiedenes',
    ];
  }

  get numberAndTitle() {
    return `${this.number} - ${this.title}`;
  }

  get commission() {
    if (!this.commission_id) { return null; }

    return this.constructor.relation('commissions').find(this.commission_id);
  }
}
